<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="分类名称：">
            <el-input v-model="query.name" placeholder="请输入分类名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.isEnable" placeholder="请选择" clearable size="small">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-dropdown @command="handleCommand">
            <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(row,1)" v-hasPermi="['goods:classify:state']">批量启用</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,2)" v-hasPermi="['goods:classify:state']">批量禁用</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-hasPermi="['goods:classify:add']">新增分类</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" row-key="id" :tree-props="{ children: 'child', hasChildren: 'hasChildren' }" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="50" />
        <el-table-column label="id" prop="id" align="center" />
        <el-table-column label="分类名称" prop="name" align="center" width="200" />
        <el-table-column label="分类图标" prop="icon" align="center">
          <template slot-scope="{row}">
            <el-image style="width: 50px; height: 50px" :src="row.icon" :preview-src-list="[row.icon]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="展示位置" prop="area" align="center">
          <template slot-scope="{row}">
            <span v-for="(item,index) in row.area" :key="index" >{{item.name}}{{row.area.length - 1 != index?',':''}}</span>
          </template>
        </el-table-column>
        <el-table-column label="页面排序 " prop="orderNo" align="center" />
        <el-table-column label="描述" prop="described" align="center" width="200" />
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
        <el-table-column label="状态" prop="isEnable" align="center">
          <template slot-scope="{row}">
            <el-switch v-hasPermi="['goods:classify:state']" v-model="row.isEnable" :active-value="true" :inactive-value="false" @change="changeSwitch(row)"></el-switch>{{row.isEnable?'启用':'禁用'}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="230">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)" v-hasPermi="['goods:classify:edit']">编辑</el-button>
            <el-button type="text" @click="handleDeleteSingle(row)" v-hasPermi="['goods:classify:delete']">删除</el-button>
            <el-button type="text" @click="handleCreate(row)" v-if="!row.parentid" v-hasPermi="['goods:classify:add']">新建二级分类</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <classify-add ref="classifyAdd" @created="doQueryList({})" :menuOptions="list" />
  </div>
</template>

<script>
import classifyAdd from './add'
import sysGoodsCategorizeApi from '@/api/goods/sysGoodsCategorize'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination,
    classifyAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        // parentid: 0,
        name: undefined,
        isEnable: undefined,
        goodsAreaIds: '3,4,5'
      },
      selectItems: []
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleFilter() {
      this.query = {}
      this.query.goodsAreaIds = '3,4,5'
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return sysGoodsCategorizeApi.fetchTreeList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => sysGoodsCategorizeApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择分类')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => sysGoodsCategorizeApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择分类')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 0)
      }
    },
    handleBatchState(ids, type) {
      let txt = type === 1 ? '确认将选中分类批量启用？' : '确认将选中分类批量禁用？'
      this.$common.confirm(txt).then(() => sysGoodsCategorizeApi.setIsEnableBatch({ ids: ids, isEnable: type ? true : false }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      sysGoodsCategorizeApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.classifyAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$refs.classifyShow.handleShow(row.id)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.classifyAdd.handleUpdate(row)
    }
  }
}
</script>
